import React, { useEffect, useRef, useState } from 'react'
import styles from './scss/aipilot.module.scss';
import ContentLayout from '../../layout/contentLayout';
import WorktualTab from '../../components/custom_components/worktualTab';
import ClvAnalysis from './clvAnalysis';
import Segmentation from './segmentation';
import BuyerPersona from './buyerPersona';
import ChurnPrediction from './churnPrediction';
import Recommendations from './recommendations';
import ClvAnalysisLyca from './clvAnalysisLyca';
import Orchestration from '../../newpages/orchestration/orchestration';

const AiPilot = () => {

  const tabs = [
    { label: 'CLV Analysis Agent', content: <ClvAnalysisLyca /> },
    // { label: 'CLV Analysis', content: <ClvAnalysis /> },
    { label: 'Segmentation Agent', content: <Segmentation /> },
    { label: 'Buyer Persona Agent', content: <BuyerPersona /> },
    { label: 'Churn Prediction Agent', content: <ChurnPrediction /> },
    // { label: 'Recommendations', content: <Recommendations /> },
    { label: 'Orchestration Agent', content: <Orchestration /> },
  ]

  return (
    <ContentLayout noPadding={true}>
      <div className={styles.titlearea}>
        <div className={styles.titlename}>AI Pilot</div>
        <div className={styles.titledesc}>Turns raw data into data-driven actions.</div>
      </div>
      <WorktualTab tabs={tabs} activeTabIndex={0} className="aicustomTab" />
    </ContentLayout>
  )
}

export default AiPilot
